import { Col, Container, Row } from 'react-bootstrap'
import { DEFAULT_ADDITIONAL_OBJECTS_LIMIT, IntegrationServiceId } from '../../../../../../../common/integrations'
import { useGetIntegrationAdminSettings } from '../../../hooks'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { Button } from '../../../../../../../components/Button/Button'
import React from 'react'
import { AdditionalObjectRow } from './AdditionalObjectsRow'
import { DetailedCRMAccountIntegrationMapping, MappingType } from '../../../../../../../models/Account'

interface CustomAdditionalObjectsAdminSettingsProps {
  serviceId: IntegrationServiceId
}

export const CustomAdditionalObjectsAdminSettings: React.FC<CustomAdditionalObjectsAdminSettingsProps> = ({ serviceId }) => {
  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)
  const { watch, setValue } = useFormContext<IntegrationSettings>()

  const additionalObjects = watch('mappings.additionalObjects') as DetailedCRMAccountIntegrationMapping[] | undefined

  const handleAddObject = () => {
    const newAdditionalObjects = additionalObjects
      ? [...additionalObjects, { objectName: null, mappingType: MappingType.CUSTOM, limit: DEFAULT_ADDITIONAL_OBJECTS_LIMIT }]
      : [{ objectName: null, mappingType: MappingType.CUSTOM }]
    setValue('mappings.additionalObjects', newAdditionalObjects)
  }

  if (isAccountFetching) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <>
      <div className='d-flex flex-column gap-3'>
        {(additionalObjects ?? []).map((obj, index) => (
          <AdditionalObjectRow serviceId={serviceId} key={obj!.objectName + index} index={index} />
        ))}
      </div>
      <Row className='mt-3'>
        <Col className='p-0'>
          <Button type='button' variant='primaryGhost' className='border-0' onClick={handleAddObject}>
            + Add object
          </Button>
        </Col>
      </Row>
    </>
  )
}
